import React from 'react';
import { Box } from '@mui/material';
import OpinionTitle from '../assets/images/my_opinion_3d.png';
import OpinionTitleDots from '../assets/images/my_opinion_dots.png';
import { translate } from 'translations/translator';
const t = key => translate('worksheet', key);

const MyOpinionTitle = ({ reasons = false }) => {
  if (reasons) {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <img
          src={OpinionTitleDots}
          alt={t('myOpinionDots')}
          style={{
            width: 375,
            height: 50,
            margin: '-10px 0px 60px 40px',
            zIndex: 2
          }}
        ></img>
      </Box>
    );
  }
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <img
        src={OpinionTitle}
        alt={t('myOpinion3D')}
        style={{
          width: 375,
          height: 45,
          margin: '-65px 0px 80px 40px',
          zIndex: 2
        }}
      ></img>
    </Box>
  );
};

export default MyOpinionTitle;
